import { AuthentificationApi } from '../../api/Authentification/AuthentificationApi'
import { TenantApi } from '../../api/Tenant/TenantApi'
import { LoginApi } from '../../api/Login/LoginApi'
import { Authentification } from '../../api/Authentification/types'

import { useSessionStore } from '../../lib/Store/sessionStore.component';
import AsyncStorage from '@react-native-async-storage/async-storage'

import { navigation } from '../../lib/Navigation/Navigation.component'
import { AccessibleDatabase } from '../../lib/Store/sessionStore.types'
import { NotifyType } from '../../components/Notification/Notification.types';


export const loadSession = async (): Promise<Authentification["user"] | null> => {
  const savedSession = await AsyncStorage.getItem('session')
  if (!savedSession) return null
  const parsed = JSON.parse(savedSession)
  if (parsed?.password) parsed.password = ''
  return parsed
}

export const saveSession = async (session: Authentification["user"]) => {
  const safe = { ...session } as any
  if (safe?.password) safe.password = ''
  await AsyncStorage.setItem('session', JSON.stringify(safe))
}

const createUserSession = (email: string, password: string, rememberMe: boolean) => {
  // Ne jamais persister le mot de passe en clair. Si l'utilisateur demande
  // "rememberMe", on conserve uniquement l'identifiant (username) et le
  // flag rememberMe — jamais le password.
  const user: any = {
    username: rememberMe ? email : '',
    rememberMe,
  };

  return user;
};

const getAccessibleDatabases = async (email: string): Promise<AccessibleDatabase[]> => {
  const tenantDatabases = await TenantApi.loadTenant();
  // Réinitialiser uniquement les bases accessibles (pas la session/token)
  useSessionStore.getState().setAccessibleDatabases([]);

  const databases = Array.isArray(tenantDatabases) ? tenantDatabases : [tenantDatabases];

  const results: AccessibleDatabase[] = [];

  for (const database of databases) {
    try {
      const components = database.components && Array.isArray(database.components)
        ? database.components.filter(c => c.type === 'DB')
        : [];

      for (const component of components) {
        try {
          await TenantApi.setContext(database.identifiant, component.identifiant);
          const response = await LoginApi.loadLogin(database.identifiant, component.identifiant, email);
          if (response?.fichesAgent) {
            results.push({ ...response, tenant: database, component });
          }
        } catch (error: any) {
          console.warn(`⚠️ Erreur lors du login pour tenant ${database.identifiant}/composant ${component.identifiant}:`, error.message || error);
        }
      }
    } catch (error) {
      console.warn(`Erreur lors de la récupération des composants pour le tenant ${database.identifiant}:`, error);
    }
  }

  return results;
};

/*
const getAccessibleDatabases = async (email: string) => {
  const tenantDatabases: Tenant = await TenantApi.loadTenant();
  const accessibleDatabases: any = [];
  const { clearSession } = useSessionStore.getState();
  clearSession();

  const databases = Array.isArray(tenantDatabases) ? tenantDatabases : [tenantDatabases];

  // Pour chaque database
  for (const database of databases) {
    const components = database.components && Array.isArray(database.components)
      ? database.components
      : [];

    // Crée un tableau de promesses pour les composants
    const loginPromises = components.map(async (component: any) => {
      try {
        const loginInfo = await LoginApi.loadLogin(database.identifiant, component.identifiant, email);
        if (loginInfo) {
          accessibleDatabases.push({
            tenant: database,
            component,
            loginInfo,
          });
          console.log(`✅ Accès accordé pour tenant ${database.identifiant}/composant ${component.identifiant}`);
        }
      } catch (error: any) {
        console.warn(`⚠️ Erreur lors du login pour tenant ${database.identifiant}/composant ${component.identifiant}:`, error.message || error);
      }
    });

    // Lance toutes les promesses en parallèle pour cette database
    await Promise.all(loginPromises);
  }

  return accessibleDatabases;
};
*/
export const onLogin = async (
  email: string,
  password: string,
  rememberMe: boolean,
  navigationObject?: any,
  notify?: NotifyType
) => {
  const store = useSessionStore.getState();
  
  try {
    const session = await AuthentificationApi.login(email, password);
    
    if (session && session.access_token) {
      // setSession au départ pour fixer le token
      store.setSession(session);
      session.user = createUserSession(email, password, rememberMe);
      
      // Initialiser la propriété base si elle n'existe pas
      session.base = {
        tenant: session?.base?.tenant ? Number(session?.base?.tenant) : 0,
        component: session?.base?.component ? Number(session?.base?.component) : 0,
        nomTenant: '',
        nomComponent: '',
        ...session.base,
      };
       
      const accessibleDatabases = await getAccessibleDatabases(email);

      store.setSession(session);

      store.setAccessibleDatabases(accessibleDatabases);

      // Navigation selon le nombre de bases de données accessibles
      switch (accessibleDatabases.length) {
        case 0:
          notify?.error('Identifiant ou mot de passe incorrect');
          break;
        case 1:
          store.selectDatabase(accessibleDatabases[0], navigationObject);
          break;
        default:
          navigation.navigate('Collectivite', navigationObject);
          break;
      }
      
      await saveSession(session.user);
    } else {
      notify?.error('Identifiant ou mot de passe incorrect');
      console.error('Erreur: aucun access token dans la réponse', session);
    }
  } catch (error: any) {
    const status = error?.response?.status;
    if (status === 401 || status === 403 || status === 400) {
      notify?.error('Identifiant ou mot de passe incorrect');
    } else {
      notify?.error('Une erreur est survenue, veuillez réessayer');
    }
    console.error('Erreur lors de la connexion:', error);
  }
};